import { ChangeEvent } from 'react';
import { Text, InputProps } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { InputNumberNimbus } from 'commons/components';
import { useInputMask } from 'commons/hooks';

interface WeighInputProps {
  appearance?: InputProps['appearance'];
  value: string;
  onChange: ({
    target: { name, value },
  }: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  placeholder?: string;
  onBlur?: () => void;
  disabled?: boolean;
  aiGenerated?: boolean;
}

function WeighInput({
  appearance = 'neutral',
  value,
  onChange,
  label,
  placeholder,
  onBlur,
  disabled = false,
  aiGenerated = false,
}: Readonly<WeighInputProps>) {
  const weightMaskRef = useInputMask({
    alias: 'decimal',
    numericInput: true,
    rightAlign: false,
    digits: 3,
    max: 9999.999,
    min: 0,
  });

  const handleBlur = () => {
    if (onBlur) onBlur();
  };

  return (
    <FormField label={label} id="depth">
      <InputNumberNimbus
        type="float"
        aria-label={label}
        ref={weightMaskRef}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        appearance={appearance}
        append={<Text color="neutral-textLow">kg</Text>}
        appendPosition="end"
        name="weight"
        onBlur={handleBlur}
        min={0}
        aiGenerated={aiGenerated}
        disabled={disabled}
      />
    </FormField>
  );
}

export default WeighInput;
